<template>
  <span :class="className">
    <span>{{ label }}</span>
    <slot></slot>
  </span>
</template>
<script setup lang="ts">
export type BadgeProps = {
  label?: string;
  variant?:
    | 'success-light'
    | 'warning'
    | 'secondary'
    | 'info-light'
    | 'light'
    | 'light-gray'
    | 'danger'
    | 'danger-light';
  isOutline?: boolean;
};
const props = defineProps<BadgeProps>();

const className = props.isOutline
  ? `badge ${props.variant}-outline`
  : `badge opacity-75 text-black bg-${props.variant}`;
</script>
<style scoped lang="scss">
.bg-danger-light {
  background-color: rgba(var(--bs-danger-rgb), 0.25);
}

.success-light-outline {
  border: 1px solid var(--bs-success-light);
  background-color: rgba(var(--bs-success-light-rgb), 0.35);
  color: var(--bs-success);
}
.warning-outline {
  background-color: rgba(var(--bs-warning-rgb), 0.25);
  color: var(--bs-secondary);
  border: 1px solid var(--bs-warning);
}
.secondary-outline {
  background-color: var(--bs-white);
  color: var(--bs-secondary);
  border: 1px solid var(--bs-secondary);
}
.info-light-outline {
  background-color: rgba(var(--bs-info-rgb), 0.25);
  color: var(--bs-info);
  border: 1px solid var(--bs-info);
}
.light-outline {
  background-color: var(--bs-white);
  color: (--bs-light);
  border: 1px solid var(--bs-light);
}
.light-gray-outline {
  background-color: var(--bs-white);
  color: var(--bs-gray);
  border: 1px solid var(--bs-light-gray);
}
.danger-outline,
.danger-light-outline {
  background-color: rgba(var(--bs-danger-rgb), 0.25);
  color: var(--bs-danger);
  border: 1px solid var(--bs-danger);
}
</style>
